import * as React from 'react';

import { Box } from '@mui/material';

import UnattachedEventReportsGroup from './UnattachedEventReportsGroup';

import { useUnattachedEventReportsData, INDIVIDUAL_REPORTS_COLLECTION_ID } from '../../core/context/UnattachedEventReportsContext';

function UnattachedEventReportsIndividualList() {
  const { individualEventReports } = useUnattachedEventReportsData();

  return (
    <Box>
      <UnattachedEventReportsGroup
        title="Ungrouped Reports"
        containerId={INDIVIDUAL_REPORTS_COLLECTION_ID}
        eventReports={individualEventReports}
      />
    </Box>
  );
}

export default UnattachedEventReportsIndividualList;
